module.exports = __webpack_public_path__ + "static/img/btn_close.f5b0139.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/details/btn_close.png
// module id = obJF
// module chunks = 156